import type { AppRouteRecordRaw } from "#src/router/types";

import { IconReader } from "#src/components/iconReader/IconReader";
import ContainerLayout from "#src/layout/container-layout";
import { createElement, lazy } from "react";

const ComponentPage = lazy(() => import("#src/features/Components"));
const JobPage = lazy(() => import("#src/features/Jobs"));
const ComponentSchedulePage = lazy(() => import("#src/features/ComponentSchedules"));
const WorkOrderPage = lazy(() => import("#src/features/WorkOrders"));
const LogbookPropertyPage = lazy(() => import("#src/features/LogbookProperties"));
const ComponentCountersPage = lazy(() => import("#src/features/ComponentCounters"));
const DefectPage = lazy(() => import("#src/features/Defects"));

const routes: AppRouteRecordRaw[] = [
	{
		path: "/pms",
		Component: ContainerLayout,
		handle: {
			title: "PMS",
			icon: createElement(IconReader, { name: "pms" }) as any as any,
			order: 3,
			keepAlive: true,
		},
		children: [
			{path: "/pms/component", Component: ComponentPage, handle: { title: "Components" }},
			{path: "/pms/job", Component: JobPage, handle: { title: "Jobs" }},

			{path: "/pms/component-schedule", Component: ComponentSchedulePage, handle: { title: "Component Schedules" }},
			{path: "/pms/work-order", Component: WorkOrderPage, handle: { title: "Work Orders" }},
			{
				handle: { title: "Maintenance Console" },
				children: [
					{path: "/pms/component-counters", Component: ComponentCountersPage, handle: { title: "Component Counters" }},
					{path: "/pms/defect", Component: DefectPage, handle: { title: "Defect" }},
				],
			},
			{
				handle: { title: "Logbook" },
				children: [
					{path: "/pms/logbook/properties", Component: LogbookPropertyPage, handle: { title: "Logbook Properties" }},
				],
			},
		],
	},
];

export default routes;
